import { useContext } from "react";
import { PageTitleContext } from "./PageTitleContextTypes";

export const usePageTitle = () => {
  const context = useContext(PageTitleContext);
  if (!context) {
    throw new Error("usePageTitle must be used within a PageTitleProvider");
  }
  return context;
};
